let labelFontSize = 8;
let pieCenter = ['50%', '55%'];
let legend = {
  orient: 'horizontal',
  top: 10,
  left: 'center',
  itemGap: 10,
  itemWidth: 25,
  itemHeight: 14,
  textStyle: {
    fontSize: 12
  }
};
let pieFontSize = 14;

const genColorPatern = i => {
  //适用于饼图
  let patern1 = [
    'rgb(40,57,87)',
    'rgb(9,78,119)',
    'rgb(20,100,169)',
    'rgb(127,136,193)',
    'rgb(176,119,100)',
    'rgb(211,80,88)',
    'rgb(198,33,39)',
    'rgb(246,142,47)',
    'rgb(255,207,107)',
    'rgb(117,196,175)',
    'rgb(49,161,207)',
    'rgb(120,100,173)'
  ];
  //和patern1颜色一样，但调整了顺序，适用于线图
  let patern2 = [
    'rgb(20,100,169)',
    'rgb(211,80,88)',
    'rgb(117,196,175)',
    'rgb(255,207,107)',
    'rgb(120,100,173)',
    'rgb(176,119,100)',
    'rgb(9,78,119)',
    'rgb(246,142,47)',
    'rgb(40,57,87)',
    'rgb(127,136,193)',
    'rgb(198,33,39)',
    'rgb(49,161,207)'
  ];
  //另外一种明亮色板
  let patern3 = [
    'rgb(66,110,183)',
    'rgb(92,83,164)',
    'rgb(134,80,158)',
    'rgb(209,73,155)',
    'rgb(235,24,119)',
    'rgb(237,30,38)',
    'rgb(251,165,26)',
    'rgb(245,236,33)',
    'rgb(155,202,60)',
    'rgb(113,192,85)',
    'rgb(112,197,164)',
    'rgb(63,185,236)'
  ];
  let arr = [patern1, patern2, patern3];
  return arr[i];
};
const StatisticsFns = {
  //渲染柱图
  genBarOpt(
    xAxisData = [],
    seriesData = [],
    color = ['rgb(211,80,88)'],
    max = 100
  ) {
    return {
      color: color,
      tootip: { formatter: '{value}%' },
      grid: {
        //containLabel: true,
        top: '20%',
        left: '20%',
        right: '10%',
        bottom: '30%'
      },
      xAxis: {
        type: 'category',
        data: xAxisData,
        axisLabel: {
          interval: 0,
          rotate: 35
        },
        splitLine: {
          show: false
        }
      },
      yAxis: {
        type: 'value',
        max: max,
        axisLabel: {
          nameTextStyle: {
            fontSize: 10
          },
          formatter: '{value}'
        },
        scale: false
      },
      series: [
        {
          data: seriesData,
          type: 'bar',
          tootip: { formatter: '{value}%' },
          label: {
            normal: {
              show: true,
              rotate: 35,
              offset: [10, -8],
              color: '#999',
              position: 'top',
              formatter: '{c}%'
            }
          }
        }
      ]
    };
  },

  //渲染单月供应商等级分布柱状图
  genBar2Opt(data) {
    let length = 1;
    let seriesData = [0, 0, 0, 0];
    if (Array.isArray(data)) {
      length = data.length;
      data.forEach(row => {
        let i = ['D', 'C', 'B', 'A'].indexOf(row.gradeInfo);
        seriesData[i] = seriesData[i] + 1;
      });
    }
    seriesData.forEach((val, i) => {
      seriesData[i] = Number(((val / length) * 100).toFixed(1));
    });
    return {
      type: 'bar',
      tooltip: {
        trigger: 'axis',
        formatter: '{b} : {c}%',
        axisPointer: {
          type: 'shadow'
        }
      },
      xAxis: {
        type: 'value',
        name: '%',
        max: 100,
        boundaryGap: [0, 0.01]
      },
      yAxis: {
        data: ['D级', 'C级', 'B级', 'A级']
      },
      series: [
        {
          type: 'bar',
          data: [
            {
              value: seriesData[0],
              itemStyle: {
                color: genColorPatern(0)[5]
              }
            },
            {
              value: seriesData[1],
              itemStyle: {
                color: genColorPatern(0)[8]
              }
            },
            {
              value: seriesData[2],
              itemStyle: {
                color: genColorPatern(0)[9]
              }
            },
            {
              value: seriesData[3],
              itemStyle: {
                color: genColorPatern(0)[2]
              }
            }
          ]
        }
      ]
    };
  },

  //渲染饼图
  genPieBarOpt(seriesName = '', seriesData = []) {
    return {
      color: ['#20a8d8', '#fad337', '#f3798e', '#a4b7c1'],
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)'
      },
      legend: legend,
      series: [
        {
          name: seriesName,
          type: 'pie',
          radius: ['45%', '65%'],
          center: pieCenter,
          data: seriesData,
          itemStyle: {
            emphasis: {
              shadowBlur: 3,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.3)'
            }
          },
          label: {
            normal: { show: true, position: 'inner', formatter: '{c}（{d}%）' },
            emphasis: {
              show: true,
              textStyle: {
                fontSize: pieFontSize,
                fontWeight: 'bold'
              }
            }
          },
          labelLine: {
            normal: {
              show: false
            }
          }
        }
      ]
    };
  },

  //渲染空心饼图
  genPieBar2Opt(data, type) {
    var seriesData = [
      { value: data.ontimeProd, name: '准时交货' },
      { value: data.delayDateProd, name: '延误交货' },
      { value: data.partDeliveryProd, name: '交货不足' },
      { value: data.notDeliveryProd, name: '未交货' }
    ];
    if (type === 2) {
      seriesData = [
        { value: data.downPrice, name: '降价' },
        { value: data.equalPrice, name: '持平' },
        { value: data.upperPrice, name: '涨价' }
      ];
    }
    let legendData = seriesData.map(item => item.name);
    return {
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b}: {c} ({d}%)'
      },
      legend: {
        // orient: 'vertical',
        left: 10,
        data: legendData
      },
      series: [
        {
          name: '数据维度',
          type: 'pie',
          radius: ['50%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '30',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: seriesData
        }
      ]
    };
  },

  // 雷达图
  getRadarOpt(radarIndicator = [], seriesData = [], seriesName = '') {
    return {
      legend: {},
      tooltip: {
        show: false
      },
      color: ['rgb(71, 189, 237)'],
      radar: {
        radius: '55%',
        name: {
          rich: {
            a: {
              color: '#20a8d8',
              lineHeight: 18,
              align: 'center'
            }
          },
          formatter: (a, b) => {
            return `{a|${a}}`;
          }
        },
        indicator: radarIndicator
      },
      series: [
        {
          type: 'radar',
          name: seriesName,
          itemStyle: { normal: { areaStyle: { type: 'default' } } },
          data: [{ value: seriesData }]
        }
      ]
    };
  },
  // 雷达图2
  getRadarOptMore(radarIndicator = [], seriesData = [], seriesName = '') {
    return {
      legend: {
        bottom: 0
      },
      tooltip: {
        show: true
      },
      color: ['#f53c3a', '#78e2f8'],
      radar: {
        radius: '55%',
        name: {
          rich: {
            a: {
              align: 'center'
            }
          },
          formatter: params => {
            var text = params.replace(/\S{5}/g, match => {
              return match + '\n';
            });
            return text;
          }
        },
        indicator: radarIndicator
      },
      series: [
        {
          type: 'radar',
          name: seriesName,
          data: seriesData,
          label: {
            normal: {
              show: true,
              formatter: function (params) {
                return params.value;
              }
            }
          },
          clickable: true
        }
      ]
    };
  }
};

export default StatisticsFns;
